// ═══════════════════════════════════════════════════════════════
// OpenGov EMC — Login Page
// Authenticates via Worker → Ignatius /token endpoint
// ═══════════════════════════════════════════════════════════════

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextInput, PasswordInput, Button, Text, Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useAuthStore } from '../../store/authStore';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, isLoading, error } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate('/');
    } catch {
      // Error is set in store
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-brand">
          <img src="/opengov_logo.png" alt="OpenGov" className="login-logo" />
        </div>

        <div className="login-card">
          <Text size="xl" fw={700} mb="lg">Sign in to your account</Text>

          {error && (
            <Alert icon={<IconAlertCircle size={16} />} color="red" mb="md" variant="light">
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextInput
              label="Email"
              placeholder="Username or email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              required
              autoFocus
              size="md"
              mb="md"
            />
            <PasswordInput
              label="Password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              required
              size="md"
              mb="lg"
            />
            <Button
              type="submit"
              fullWidth
              loading={isLoading}
              size="md"
              color="#4B3FFF"
            >
              Continue
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
